// extracted by mini-css-extract-plugin
export default {"bgVid":"Header_bgVid__2mmUb","rowHeader":"Header_rowHeader__574ry","contentStory":"Header_contentStory__uNVbw","headerImage":"Header_headerImage__spClb","img":"Header_img__K4V7I"};